import { CheckCircleIcon } from "@heroicons/react/24/solid"
import PropTypes from 'prop-types'

const ImageRadioGroup = ({ 
  classNames = {}, 
  handleChange, 
  options, 
  selectedOptionIds = [], 
  isDisabled = false,
  multiSelect = true,
  flexDirection = "column"
}) => {
  const getOptionIdsArray = (optionId) => {
    return selectedOptionIds.includes(optionId)
      ? selectedOptionIds.filter((id) => id !== optionId)
      : [...selectedOptionIds, optionId]
  }

  const containerClasses = classNames?.container || ""
  const itemClasses = classNames?.items || ""

  return (
    <div className={`flex gap-3 ${containerClasses}`}>
      {Object.keys(options).map(key => {
        const option = options[key]
        const isSelected = selectedOptionIds.includes(option.id)

        return (
          <div
            key={option.id}
            className={`${itemClasses} grow ${isDisabled ? 'pointer-events-none' : 'hover:cursor-pointer'} border-8 flex items-center justify-center ${flexDirection === "row" ? "flex-row" : "flex-col"} relative rounded-lg p-6 transition-all duration-300 ${isSelected ? 'border-green-200 bg-green-500' : 'border-gray-200 bg-gray-500 dark:bg-content2 border-4'}`}
            onClick={() => handleChange(multiSelect ? getOptionIdsArray(option.id) : option.id)}
          >
            {isSelected && <CheckCircleIcon className={`absolute ${flexDirection === 'row' ? 'h-10 -top-4 -right-3' : 'h-16 -top-6 -right-5'} text-green-200`} />}

            <div className="text-white opacity-70">{option.image}</div>

            <div className={`${flexDirection === "row" ? "text-left ml-3" : "text-center mt-3"}`}>
              <h1 className={`${flexDirection === "row" ? "text-base" : "text-xl"} font-semibold text-white`}>
                {option.label}
              </h1>

              <p className="text-sm text-white">{option.description}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

ImageRadioGroup.propTypes = {
  classNames: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  multiSelect: PropTypes.bool,
  options: PropTypes.object.isRequired,
  selectedOptionIds: PropTypes.array,
}

export default ImageRadioGroup
